import React, { Component } from "react";
import Security from "../../../security";
import {
  SignIn,
  ConfirmOTPContainer,
  NewPasswordComponent
} from "../authentication/";
import { MuiTypography } from "../../ui/MaterialUIComponents";
import { connect } from "react-redux";
import { DashBoardContainer } from '../dashboard'
import { I18nActions, ContextualHelpActions, SystemConfigActions } from '../../../store'
import lodashUtil from 'lodash'
import spinner from '../../ui/icons/spinner.gif'
import theme from "../../../assests";

class Main extends Component {
  componentWillMount() {
    if (this.props.user != null && this.props.state === Security.SigninState.LOGGING_IN) {
      if (localStorage.getItem('rememberMe') !== 'true' && localStorage.getItem('browserCloseTime') !== 'undefined' && new Date().getTime() - Number(localStorage.getItem('browserCloseTime')) > 1000 * 60 * 15 * 1) {
        localStorage.setItem('browserCloseTime', 'undefined')
        this.props.user.signOut();
      }
    }
  }
  componentDidMount() {
    if (this.props.contextualHelp !== undefined || lodashUtil.isEmpty(this.props.contextualHelp)) {
      this.props.getContextualHelp()
    }
    this.props.getI18nMessages();
    this.props.getSystemConfig()
  }
  render() {
    switch (this.props.state) {
      case Security.SigninState.LOGGED_IN:
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
          return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
        } else {
          return (
            < DashBoardContainer {...this.props} />);
        }

      case Security.SigninState.AUTHENTICATED:
        return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />

      case Security.SigninState.LOGGING_IN:
        return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
      case Security.SigninState.LOGGED_OUT:
        return <SignIn {...this.props} />

      case Security.SigninState.LOGIN_FAILURE:
        return <DashBoardContainer {...this.props} />;

      //   case Security.SigninState.FORCE_CHANGE_PASSWORD:
      //     return <div>Hello</div>;

      case Security.SigninState.NEW_PASSWORD_REQUIRED:
        return <NewPasswordComponent {...this.props} />;
      case Security.SigninState.EMAIL_VERIFICATION_REQUIRED:
        return <ConfirmOTPContainer {...this.props} />;

      case Security.SigninState.CONFIRMATION_REQUIRED:
        return <ConfirmOTPContainer {...this.props} />;
      default:
        return (
          <div>
            <p>Unrecognised cognito state</p>
          </div>
        );
    }
  }
}

const mapStateToProps = state => ({
  state: state.cognito.state,
  user: state.cognito.user,
  attributes: state.cognito.attributes,
  contextualHelp: state.contextualHelp.contextualHelp,
  i18n: state.i18nMessages.i18n,
  systemConfig: state.systemConfig.systemConfig
});

const mapDispatchToProps = dispatch => {
  return {
    getContextualHelp: () => dispatch(ContextualHelpActions.getContextualHelp()),
    getI18nMessages: () => dispatch(I18nActions.getI18nMessages()),
    getSystemConfig: () => dispatch(SystemConfigActions.getSystemConfig())
  };
};
const ConnectedMain = connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);

export default ConnectedMain;
